import React from 'react';
import { motion } from 'framer-motion';
import { FactoryIcon, RulerIcon, TargetIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-[#020202]" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-194">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-195">
            Ok, pero… ¿qué hace a esto distinto?
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-196">
            La diferencia no es "usar IA". La diferencia es el{' '}
            <span className="text-white font-bold" data-id="element-197">mecanismo</span>:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-198">
          {[{
          icon: FactoryIcon,
          title: '1) Volumen industrial',
          desc: '100 creativos en minutos (no en días). Tu semana de testing aparece de golpe. Olvidate del cuello de botella creativo.'
        }, {
          icon: RulerIcon,
          title: '2) Multi-ángulo real',
          desc: 'No te tira variaciones cosméticas. Te genera ángulos distintos: dolor, deseo, objeción, transformación, urgencia.'
        }, {
          icon: TargetIcon,
          title: '3) Diseñado para productos digitales',
          desc: "Ebooks y cursos se venden con: claridad + promesa + prueba + emoción. No con 'diseñitos' bonitos que no convierten."
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.5
        }} className="glass-card p-8 rounded-2xl hover:bg-white/[0.05] transition-all duration-300 group" data-id="element-199">
              <div className="w-14 h-14 bg-purple-900/20 rounded-xl flex items-center justify-center mb-6 text-purple-400 group-hover:scale-110 transition-transform duration-300 border border-purple-500/20" data-id="element-200">
                <item.icon className="w-7 h-7" data-id="element-201" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-white group-hover:text-purple-200 transition-colors" data-id="element-202">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-203">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}